module.exports = __webpack_public_path__ + "img/pbc-library.46a8573f.jpg";